




import {auth, authProp} from'../firebaseConfig';
import firebaseui from 'firebaseui';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Auth extends Vue {
name: string = 'auth';
mounted() {
    let uiConfig = {
        signInSuccessUrl: '/success',
        signInOptions: [
             authProp.EmailAuthProvider.PROVIDER_ID,
             authProp.PhoneAuthProvider.PROVIDER_ID
        ]
    };
    let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    ui.start('#firebaseui-auth-container', uiConfig);
    }
}   
